export const MAINTENANCE_TASK_PROCESS_STEP_MEASURE_VALUE_FIELD_NAME =
  "measureValue";
export const MAINTENANCE_TASK_PROCESS_STEP_CHECK_RESULT_FIELD_NAME =
  "checkResult";
export const MAINTENANCE_TASK_PROCESS_STEP_REMARKS_FIELD_NAME = "remarks";
